import { CommentItem, RestAPI } from '@builddocs/data-management'

interface IRestoreCommentsFromHistory {
  externalId: string
  externalEntityInfo: string
  commentIds: string[]
}

export function restoreCommentsFromHistory({
  externalId,
  externalEntityInfo,
  commentIds,
}: IRestoreCommentsFromHistory) {
  return RestAPI.post<CommentItem[]>(
    `section_four/external-entity-id/${externalId}/attach?externalEntityInfo=${externalEntityInfo}`,
    commentIds,
  ).then(r => r.data)
}
